import { render, staticRenderFns } from "./stepContent.vue?vue&type=template&id=22ccee28&scoped=true"
import script from "./stepContent.vue?vue&type=script&lang=js"
export * from "./stepContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ccee28",
  null
  
)

export default component.exports